import { render, staticRenderFns } from "./CornerIconJoystick.vue?vue&type=template&id=3206add4&scoped=true&"
import script from "./CornerIconJoystick.vue?vue&type=script&lang=js&"
export * from "./CornerIconJoystick.vue?vue&type=script&lang=js&"
import style0 from "./CornerIconJoystick.vue?vue&type=style&index=0&id=3206add4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206add4",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImg} from 'bootstrap-vue'
    installComponents(component, {BImg})
    

export default component.exports